import webBiLogger from '@wix/web-bi-logger';

import { getConfig } from '../../config';

import { BI_LOGGER_ACTION_NAMES } from './bi-logger.constants';
import { BiEvent } from './bi-logger.types';

export const initLogger = ({ schema }) => {
  const defaultParams = {
    src: 25,
  };

  const logger = webBiLogger
    .factory({
      endpoint: 'wixmp',
      host: getConfig().api.biUrl,
    })
    .updateDefaults(defaultParams)
    .logger();

  return {
    log(event, params = {}) {
      return logger.log({ evid: event.id, ...params });
    },
  };
};

export const biLoggerActionCreator = ({
  event,
  params = {},
}: {
  event: BiEvent;
  params?: {};
}) => ({
  type: BI_LOGGER_ACTION_NAMES.EVENT,
  payload: {
    event,
    params,
  },
});
